import React from "react";
import { observer } from "mobx-react";

const NutritionDraftStatusPill = observer(function NutritionDraftStatusPill({
  session: _session,
  style: _style = null,
}) {
  // Keep the component mounted in existing views, but disable the visible pill.
  return null;
});

export default NutritionDraftStatusPill;
